module.exports = __webpack_public_path__ + "static/img/pic-bg-active-1.d9e4e03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/pic-bg-active-1.png
// module id = bNYc
// module chunks = 0